import Vue from 'vue'

/**数字验证**/
const int = Vue.directive('int', {
	inserted: function(el, binding, vnode) {
		const input = el.getElementsByTagName('input')[0];
		//添加@input事件
		input.onkeyup = function(e) {
			var regStrs = [
				['/^\d+$/', ''], //整数验证
				['^0(\\d+)$', ''], //禁止录入整数部分两位以上，但首位为0
				['[^\\d\\.]+$', ''], //禁止录入任何非数字和点
				['/\./', ''], //禁止录入任何点
				['\\.(\\d?)\\.+', ''], //禁止录入任何点\
				['^(\\d+\\.\\d{0}).+', ''] //禁止录入小数点后两位以上
			];
			for (var i = 0; i < regStrs.length; i++) {
				var reg = new RegExp(regStrs[i][0]);
				input.value = input.value.replace(reg, regStrs[i][1]);
			}
			trigger(input, 'input')
		}

		//添加@blur事件，光标切换之后对数字进行处理
		input.onblur = function(e) {
			var v = input.value;
			if (v === '') {
				v = '0';
			} else if (v === '0') {
				v = '0';
			} else if (v === '0.') {
				v = '0';
			} else if (v === '.') {
				v = '0';
			} else if (/^0+\d+\.?\d*.*$/.test(v)) {
				v = v.replace(/^0+(\d+\.?\d*).*$/, '');
				v = inp.getRightPriceFormat(v).val;
			} else if (/^0\.\d$/.test(v)) {
				//v = v + '0';
				v = v;
			} else if (!/^\d+\.\d{2}$/.test(v)) {

				if (/^\d+\.\d{2}.+/.test(v)) {
					v = v.replace(/^(\d+\.\d{2}).*$/, '');

				} else if (/^\d+$/.test(v)) {
					v = v + '';
				} else if (/^\d+\.$/.test(v)) {
					//v = v;
					v = v.replace(/\./, '');
				} else if (/^\d+\.\d$/.test(v)) {
					v = v;
				} else if (/^[^\d]+\d+\.?\d*$/.test(v)) {
					v = v.replace(/^[^\d]+(\d+\.?\d*)$/, '');
				} else if (/\d+/.test(v)) {
					v = v.replace(/^[^\d]*(\d+\.?\d*).*$/, '');
				} else if (/^0+\d+\.?\d*$/.test(v)) {
					v = v.replace(/^0+(\d+\.?\d*)$/, '');
				} else {
					v = '0';
				}
			}
			input.value = v;
		}
		trigger(input, 'input');
	},
});

/**数字验证**/
const decimal = Vue.directive('decimal', {

	inserted: function(el, binding, vnode) {
		const input = el.getElementsByTagName('input')[0];
		//添加@input事件
		input.onkeyup = function(e) {
			var regStrs = [
				['^0(\\d+)$', '$1'], //禁止录入整数部分两位以上，但首位为0
				['[^\\d\\.]+$', ''], //禁止录入任何非数字和点
				['\\.(\\d?)\\.+', '.$1'], //禁止录入两个以上的点
				['^(\\d+\\.\\d{2}).+', '$1'] //禁止录入小数点后两位以上
			];
			for (var i = 0; i < regStrs.length; i++) {
				var reg = new RegExp(regStrs[i][0]);
				input.value = input.value.replace(reg, regStrs[i][1]);
			}
			trigger(input, 'input')
		}

		//添加@blur事件，光标切换之后对数字进行补位
		input.onblur = function(e) {
			var v = input.value;
			if (v === '') {
				v = '0.00';
			} else if (v === '0') {
				v = '0.00';
			} else if (v === '0.') {
				v = '0.00';
			} else if (v === '.00') {
				v = '0.00';
			} else if (/^0+\d+\.?\d*.*$/.test(v)) {
				v = v.replace(/^0+(\d+\.?\d*).*$/, '$1');
				v = inp.getRightPriceFormat(v).val;
			} else if (/^0\.\d$/.test(v)) {
				v = v + '0';
			} else if (!/^\d+\.\d{2}$/.test(v)) {

				if (/^\d+\.\d{2}.+/.test(v)) {
					v = v.replace(/^(\d+\.\d{2}).*$/, '$1');

				} else if (/^\d+$/.test(v)) {
					v = v + '.00';
				} else if (/^\d+\.$/.test(v)) {
					v = v + '00';
				} else if (/^\d+\.\d$/.test(v)) {
					v = v + '0';
				} else if (/^[^\d]+\d+\.?\d*$/.test(v)) {
					v = v.replace(/^[^\d]+(\d+\.?\d*)$/, '$1');
				} else if (/\d+/.test(v)) {
					v = v.replace(/^[^\d]*(\d+\.?\d*).*$/, '$1');
				} else if (/^0+\d+\.?\d*$/.test(v)) {
					v = v.replace(/^0+(\d+\.?\d*)$/, '$1');
				} else {
					v = '0.00';
				}
			}
			input.value = v;
		}
		trigger(input, 'input');
	}
});

const trigger = (el, type) => {
	const e = document.createEvent('HTMLEvents')
	e.initEvent(type, true, true)
	el.dispatchEvent(e)
}

export {
	int,
	decimal
}